<div class="identify-buttons">
    <button class="btn street-view" *ngIf="showOpenStreetViewButton" (click)="openStreetView()">
        <span class="esri-icon-map-pin"></span>
        Open Street View
    </button>
    <button class="btn" *ngIf="showOpenReportsButton" (click)="openReports()">
        <span class="icon-ui-documentation"></span>
        Open Reports
    </button>
</div>